module.exports = __webpack_public_path__ + "img/535f0e3.jpg";